import Backbone from "extensions/backbone";

import { user } from "common/config/api";

import { Config } from "merchant/features/analytics/common/configModel";

export const ReportsCollection = Backbone.Collection.extend({
    url: user.reports,
    model: Config
});
